import React from "react"
import { Box, Skeleton, Typography } from "@mui/material"
import { useDateTable } from "Pages/Main/Page/@hooks"
import { AppBasicTable } from "@components"
import { dateColumn, searchesColumn, sitesColumn, usersColumn } from "./columns"
import SearchAnalyticsCustomTableToolbar from "Pages/Main/Page/Content/DataTables/Toolbar"
import {formatDate, postExcel} from "@ui-seeker/utils";
import {BACKEND_APIS} from "../../../../../@constants";
import {BIFilters} from "../../../../BusinessLogistics/BI/Page/@signals";
import {companyUsers, dateRange, userData} from "../../../../../@signals";

export default function SearchAnalyticsTables({ userSiteTableData, dateUserTableData, isDateRangeLoading, ...props }) {

	const { showDateTable, setShowDateTable } = useDateTable()
	if (isDateRangeLoading) return <Skeleton variant="rectangular" height={400}/>

	return <AppBasicTable
		data={showDateTable ? dateUserTableData?.bookingDateUser : userSiteTableData}
		Components={{
			Title: () => <Box>
				<Typography variant="h6">
					{`Summary of searches per ${showDateTable ? "Date & User" : "User & Site"}`}
				</Typography>
				<SearchAnalyticsCustomTableToolbar setShowDateTable={setShowDateTable} showDateTable={showDateTable}/>
			</Box>
		}}
		sx={{ height: 250 }}
		headers={[[
			{ label: showDateTable ? "Date" : "Name" },
			{ label: showDateTable ? "Name" : "Website" },
			{ label: "Searches" },
		]]}
		columns={showDateTable
			? [dateColumn(), usersColumn(), searchesColumn()]
			: [usersColumn(), sitesColumn(), searchesColumn()]}
		setHeaderCellProps={(_, idx) => ({
			sx: {
				width: 1 / 3,
				backgroundColor: 'primary.main',
				textAlign: idx !== 2 && "left !important"
			}
		})}
		{...props}
	/>
}